<link href="/assets/css/style.css" rel="stylesheet">
<link href="/assets/css/style.css" rel="stylesheet">
<link href="/fr/assets/css/style.css" rel="stylesheet">
<link href="/en/assets/css/style.css" rel="stylesheet">
<link href="/es/assets/css/style.css" rel="stylesheet">
<link href="/pt/assets/css/style.css" rel="stylesheet">
<link href="/ko/assets/css/style.css" rel="stylesheet">
<app-online-course-header></app-online-course-header>
<section class="content-section course_online">
  <div class="container" appDynamicDirection>
    <div _ngcontent-c1="">
      <h1 class="heading" i18n>The online course</h1>
      <div i18n >
        <p>To address capacity building for systematic and effective use of SDG-PSS, the online course provides training and teaching on how to use this system to produce evidence and data on the enabling environment for achieving SDG 6. Filling the SDG-PSS with data may require significant efforts from various government agencies and may be time-consuming, as data may not be promptly available for all targets and indicators of SDG 6. Nevertheless, the efforts required by the SDG-PSS to get all the evidence together is an essential step for countries to better evaluate which data is missing and where gaps in policy-making exist.<br><br>
        The SDG-PSS e-course consists of the following modules: introduction to SDG-PSS; accessing SDG-PSS and registering in the system; SDG-PSS components; entering data in the SDG-PSS; and reporting in the SDG-PSS. Each module consists of video lectures, reading supplements, graded evaluations. Anyone engaged in this course will be able to share their questions and comments about the e-course. The project team will follow up on these questions/comments.<br><br></p>
        <h2 class="heading">Key learnings</h2>
        <p>Upon completion of this self-paced online course, the participants should be able to navigate through SDG-PSS pages and its components; use SDG-PSS to generate and analyze critical evidence on the enabling environment of the achievement of SDG 6.<br><br></p>
        <h2 class="heading">Intended users</h2>
        <p>The online course is designed for water-focused policy makers, practitioners, and researchers.<br><br></p>
        <h2 class="heading">Module Subjects</h2>
        <ol>
        <li>Introduction to SDG-PSS</li>
        <li>Accessing and registering in the tool</li>
        <li>SDG-PSS critical components</li>
        <li>Entering data in the SDG-PSS</li>
        <li>Reporting in the SDG-PSS</li>
        </ol> <p><br></p>
        <h2 class="heading">Access to online course</h2>
        <p>To access the online course, please click on the buttons below.</p><br><br>
      </div>
    </div>
    <div class="row" appDynamicDirection>
        <div class="col-md-2 col-lg-2">
        </div>
          <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 login-buttons">
            <div class="three_btn">
              <a href="https://lc.unu.edu/courses/course-v1:UNU-INWEH+INWEH-03+2019/about" target="self"><div class="col-xs-12 col-sm-6 col-md-8 btn btn-default btn-radius home-button" style="margin-bottom: 15px; padding-top:12px; padding-bottom: 12px; " ><p i18n>English</p></div></a>
              <a href="https://lc.unu.edu/courses/course-v1:UNU-INWEH+INWEH-13+2019/about" target="self"><div class="col-xs-12 col-sm-6 col-md-8 btn btn-default btn-radius home-button" style="margin-bottom: 15px; padding-top:12px; padding-bottom: 12px;"  ><p i18n>French</p></div></a>
              <a href="https://lc.unu.edu/courses/course-v1:UNU-INWEH+INWEH-14+2020/about" target="self"><div class="col-xs-12 col-sm-6 col-md-8 btn btn-default btn-radius home-button" style="margin-bottom: 15px; padding-top:12px; padding-bottom: 12px;"  ><p i18n>Spanish</p></div></a>
            </div>
          </div>
          <div class="col-md-2 col-lg-2">
          </div>
    </div>
  </div>
  </section>



// WEBPACK FOOTER //
// ./src/app/online-course/online-course.component.html